import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'
import { investigationLabel } from '@/frontend/features/Fde/investigations/format'
import type { InvestigationLabels } from '@/frontend/features/Fde/investigations/types'

export default function StatusBadge({ status, copy }: { status: string; copy: InvestigationLabels }) {
  const active = ['queued', 'running', 'investigating', 'stopping'].includes(status)
  return <span className={cn('inline-flex shrink-0 items-center gap-1.5 rounded-full px-2 py-0.5 text-[11px] font-medium',
    active ? 'bg-blue-50 text-blue-800 dark:bg-blue-950/40 dark:text-blue-200' : 'bg-muted text-muted-foreground',
    ['failed', 'error'].includes(status) && 'bg-destructive/10 text-destructive',
    ['supported', 'observed'].includes(status) && 'bg-emerald-50 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-200')}>
    {active && <Loader2 className="size-3 animate-spin motion-reduce:animate-none" aria-hidden />}
    {investigationLabel(copy, 'status', status)}
  </span>
}
